/** Fixed size (px) for VAPI user camera perspective corner handles in edit mode. */
export const VAPI_PERSPECTIVE_CORNER_HANDLE_SIZE_PX = 12;

/** Fixed size (px) for VAPI transcription perspective corner handles in edit mode. */
export const VAPI_TRANSCRIPTION_CORNER_HANDLE_SIZE_PX = 24;

function cornerHandleBase(sizePx) {
    return (
        `position:absolute;width:${sizePx}px;height:${sizePx}px;` +
        'border-radius:50%;border:2px solid #0af;background:rgba(0,170,255,0.4);cursor:grab;transform:translate(-50%,-50%);z-index:3;'
    );
}

/**
 * @param {string} [suffix] e.g. 'pointer-events:auto;' or 'pointer-events:none;display:none;'
 */
export function vapiPerspectiveCornerHandleStyle(suffix = '') {
    return cornerHandleBase(VAPI_PERSPECTIVE_CORNER_HANDLE_SIZE_PX) + suffix;
}

/**
 * Transcription panel corner handles (larger hit target than camera).
 * @param {string} [suffix] e.g. 'pointer-events:auto;' or 'pointer-events:none;display:none;'
 */
export function vapiTranscriptionPerspectiveCornerHandleStyle(suffix = '') {
    return cornerHandleBase(VAPI_TRANSCRIPTION_CORNER_HANDLE_SIZE_PX) + suffix;
}
